import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SmashCguCookiesModule } from '@app/shared/modules/smash-cgu-cookies/smash-cgu-cookies';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';
import { SharedModule } from '@app/shared/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ForgotPasswordModule } from './modules/forgot-password/forgot-password.module';
import { InviteModule } from './modules/invite/invite.module';
import { MfaModule } from './modules/mfa/mfa.module';
import { RenewPasswordModule } from './modules/renew-password/renew-password.module';
import { SigninComponent } from './signin.component';
import { SIGNIN_ROUTES } from './signin.routes';
import { ForgotPasswordEffects } from '../store/effects/forgot-password.effects';
import { InviteEffects } from '../store/effects/invite.effects';
import { RenewPasswordEffects } from '../store/effects/renew-password.effects';
import { SigninEffects } from '../store/effects/signin.effects';
import * as fromSigninModule from '../store/reducers';
import { MfaEffects } from '../store/effects/mfa.effects';

@NgModule({
  declarations: [SigninComponent],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    StoreModule.forFeature(fromSigninModule.signinModuleFeatureKey, fromSigninModule.reducers),
    EffectsModule.forFeature([SigninEffects, ForgotPasswordEffects, RenewPasswordEffects, InviteEffects, MfaEffects]),
    RouterModule.forChild(SIGNIN_ROUTES),
    SmashCguCookiesModule,
    RenewPasswordModule,
    ForgotPasswordModule,
    InviteModule,
    MfaModule,
  ]
})
export class SigninModule { }
